import { render, staticRenderFns } from "./productModel.vue?vue&type=template&id=2bc7ff0d&scoped=true&"
import script from "./productModel.vue?vue&type=script&lang=js&"
export * from "./productModel.vue?vue&type=script&lang=js&"
import style0 from "./productModel.vue?vue&type=style&index=0&id=2bc7ff0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7ff0d",
  null
  
)

export default component.exports